import axios from 'axios'
import { formatDateForServer, parseDateFromServer, formatTimeForServer, parseTimeFromServer } from '../../../functions/dateHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

import {
  savingChartPhase,
  chartFieldSaved,
  errorSavingChartPhase,
  errorSavingChartDate,
  handleChartFieldChange,
 } from './chartFormReducer'


const defaultState = {
  reasonToStartCefiderocol: '',
  reasonToStartCefiderocolOtherText: '',
  cefiderocolInitiationDate: null,
  cefiderocolInitiationTime: null,
  cefiderocolRecommendedBy: '',
  attendingPhysicianSpecialty: '',
  cefiderocolStartingDoseGrams: '',
  cefiderocolInfusionTimeHours: '',
  cefiderocolInfusionFrequencyHours: '',
  patientBodyWeight: '',
  serumCreatineLevel: '',
  serumCreatineLevelUnit: '',
  cefiderocolEndDate: null,
  reasonForEndingCefiderocol: '',
  reasonForEndingCefiderocolOtherText: '',
  patientReceivedOtherAntimicrobials: false,
  clinicalAssessmentCefiderocolTreatment: '',
  gnbiMicrobiologyRepeated: false,
  gnbiDateOfSampleTest: null,
  gnbiPathogens: '',


  // deviceRemovedOrReplaced: false,
  // deviceRemovedOrReplacedDate: null,

  patientExperiencedAdverseEvents: false,

  patientAdmittedToICU: false,

  icuAdmissions: [],
  savingICUAdmissions: false,

  additionalAntimicrobials: [],
  savingAdditionalAntimicrobial: false,

  cefiderocolAdverseEvents: [],
  savingCefiderocolAdverseEvent: false,

  
  antibioticsUseInfoUrl: '',
  displayPatientBodyWeightModal: false,
  displayAntibioticsScreeningFailure: false
}

export default function antibioticsUseFormReducer(state = defaultState, action) {
  switch (action.type) {
    case "CHART_HAS_BEEN_DELETED":
      return defaultState
    case "CHANGE_EDIT_CHART_PHASE":
      return { ...state, chartPhase: action.payload }

    case "TOGGLE_PATIENT_BODY_WEIGHT_MODAL":
      return { ...state, displayPatientBodyWeightModal: action.payload }

    case "TOGGLE_ANTIBIOTICS_SCREENING_FAILURE":
      return { ...state, displayAntibioticsScreeningFailure: action.payload }

    case "HANDLE_ANTIBIOTICS_USE_FORM_FIELD_CHANGE":
      return { ...state, [action.payload.key]: action.payload.value }

    case "ANTIBIOTICS_USE_TOGGLE_GNBI_MICROBIOLOGY_REPEATED":
      return {
        ...state,
        gnbiMicrobiologyRepeated: action.payload,
        gnbiDateOfSampleTest: null,
        gnbiPathogens: '',
      }

    // case "ANTIBIOTICS_USE_TOGGLE_DEVICE_REMOVED_OR_REPLACED":
    //   return {
    //     ...state,
    //     deviceRemovedOrReplaced: action.payload,
    //     deviceRemovedOrReplacedDate: null,
    //   }

    case "ANTIBIOTICS_USE_TOGGLE_PATIENT_EXPERIENCED_ADVERSE_EVENTS":
      let cefiderocolAdverseEvents = []
      if (action.payload === true) {
        cefiderocolAdverseEvents = [
          {id: 1, name: '', date_of_onset: null, event_duration_days: '', event_severity: '', event_seriousness: '', event_seriousness_reason: '', event_outcome: '', event_reported_to_health_authority: '', url: '', deleted: false, time_to_onset: 0, indication_for_treatment: ''},
        ]
      }
      return {
        ...state,
        patientExperiencedAdverseEvents: action.payload,
        cefiderocolAdverseEvents,
      }

    case "ANTIBIOTICS_USE_ADVERSE_EVENT_FIELD_CHANGE":
      const adverseEvents = updateAssociatedField(action.payload.id, action.payload.name, action.payload.value, state.cefiderocolAdverseEvents)
      return { ...state, cefiderocolAdverseEvents: adverseEvents, savingAdverseEvent: false }

    case "ANTIBIOTICS_USE_ADD_CEFIDEROCOL_ADVERSE_EVENT":
      return {
        ...state,
        cefiderocolAdverseEvents: [...state.cefiderocolAdverseEvents, action.payload]
      }

    case "ANTIBIOTICS_USE_SAVING_CEFIDEROCOL_ADVERSE_EVENT":
      return { ...state, savingCefiderocolAdverseEvent: true }

    case "ANTIBIOTICS_USE_REMOVE_CEFIDEROCOL_ADVERSE_EVENT":
      return {
        ...state,
        cefiderocolAdverseEvents: state.cefiderocolAdverseEvents.filter(adverseEvent => {
          return adverseEvent.id !== action.payload
        })
      }

    case "ANTIBIOTICS_USE_TOGGLE_PATIENT_RECEIVED_ADDITIONAL_ANTIMICROBIALS":
      let additionalAntimicrobials = []
      if (action.payload === true) {
        additionalAntimicrobials = [{id: 1, drug_name: '', initiation_date: null, end_date: null}]
      }
      return {
        ...state,
        patientReceivedOtherAntimicrobials: action.payload,
        additionalAntimicrobials,
      }

    case "ANTIBIOTICS_USE_ADDITIONAL_ANTIMICROBIAL_FIELD_CHANGE":
      const updatedAntimicrobials = updateAssociatedField(action.payload.id, action.payload.name, action.payload.value, state.additionalAntimicrobials)
      return { ...state, additionalAntimicrobials: updatedAntimicrobials }

    case "ANTIBIOTICS_USE_ADD_ADDITIONAL_ANTIMICROBIAL":
      return {
        ...state,
        additionalAntimicrobials: [...state.additionalAntimicrobials, action.payload]
      }

    case "ANTIBIOTICS_USE_REMOVE_ADDITIONAL_ANTIMICROBIAL":
      return {
        ...state,
        additionalAntimicrobials: state.additionalAntimicrobials.filter(antimicrobial => {
          return antimicrobial.id !== action.payload
        })
      }

    case "ANTIBIOTICS_USE_SAVING_ADDITIONAL_ANTIMICROBIAL":
      return { ...state, savingAdditionalAntimicrobial: true }

    case "ANTIBIOTICS_USE_TOGGLE_PATIENT_WAS_ADMITTED_TO_ICU":
      let icuAdmissions = []
      if (action.payload === true) {
        const newICUAdmission = createBlankICUAdmission(1)
        icuAdmissions.push(newICUAdmission)
      }
      return {
        ...state,
        patientAdmittedToICU: action.payload,
        icuAdmissions,
      }

    case "ANTIBIOTICS_USE_ICU_ADMISSION_FIELD_CHANGE":
      const updatedICUAdmissions = updateAssociatedField(action.payload.id, action.payload.name, action.payload.value, state.icuAdmissions)
      return { ...state, icuAdmissions: updatedICUAdmissions, savingICUAdmissions: false }

    case "ANTIBIOTICS_USE_ADD_ICU_ADMISSION_INSTANCE":
      return {
        ...state,
        icuAdmissions: [...state.icuAdmissions, action.payload]
      }

    case "ANTIBIOTICS_USE_REMOVE_ICU_ADMISSION_INSTANCE":
      return {
        ...state,
        icuAdmissions: state.icuAdmissions.filter(admission => {
          return admission.id !== action.payload
        })
      }

    case "CHART_ANTIBIOTICS_USE_INFO_HAS_BEEN_SAVED":
      return { ...state, antibioticsUseInfoUrl: action.payload.antibioticsUseInfoUrl }

    case "SET_CHART_FROM_SERVER_TO_FORM":
      const antibioticsUse = resetAntibioticsUseFormFromServer(action.payload)

      return {
        ...state,
        ...antibioticsUse,
      }
    case "MARK_CHART_AS_COMPLETED":
      return defaultState
    default:
      return state
  }
}


export const handleAntibioticsUseChartFieldChange = (key, value) => {
  return { type: "HANDLE_ANTIBIOTICS_USE_FORM_FIELD_CHANGE", payload: { key, value } }
}

export const togglePatientBodyWeightModal = (display) => {
  return { type: "TOGGLE_PATIENT_BODY_WEIGHT_MODAL", payload: display }
}

const chartAntibioticsUseHasBeenSaved = (antibioticsUseInfoUrl, goToNextPhase) => {
  return {
    type: "CHART_ANTIBIOTICS_USE_INFO_HAS_BEEN_SAVED",
    payload: { antibioticsUseInfoUrl, goToNextPhase }
  }
}

export const toggleGnbiMicrobiologyRepeated = (payload) => {
  return { type: "ANTIBIOTICS_USE_TOGGLE_GNBI_MICROBIOLOGY_REPEATED", payload }
}


// export const toggleDeviceRemovedOrReplaced = (payload) => {
//   return { type: "ANTIBIOTICS_USE_TOGGLE_DEVICE_REMOVED_OR_REPLACED", payload }
// }






export const updateAssociatedField = (id, name, value, associatedFieldArray) => {
  const index = associatedFieldArray.findIndex(element => element.id === id)

  if (index < 0) {
    return associatedFieldArray
  }

  const updatedObject = { ...associatedFieldArray[index], [name]: value }

  const updateAssociatedFieldArray = [
    ...associatedFieldArray.slice(0, index),
    updatedObject,
    ...associatedFieldArray.slice(index + 1)
  ]

  return updateAssociatedFieldArray
}


const resetAntibioticsUseFormFromServer = (patientChart) => {
  if (!patientChart.antibiotics_use) {
    return {}
  }

  const antibioticsUse = patientChart.antibiotics_use

  const numberFields = [
    {serverName: 'cefiderocol_starting_dose_grams', reducerName: 'cefiderocolStartingDoseGrams'},
    {serverName: 'cefiderocol_infusion_time_hours', reducerName: 'cefiderocolInfusionTimeHours'},
    {serverName: 'cefiderocol_infusion_frequency_hours', reducerName: 'cefiderocolInfusionFrequencyHours'},
    {serverName: 'patient_body_weight_kg', reducerName: 'patientBodyWeight'},
    {serverName: 'serum_creatine_level_value', reducerName: 'serumCreatineLevel'},
    {serverName: 'apache_ii_score', reducerName: 'apahceIIScore'},
  ]

  let numberFieldsFromServer = {}

  numberFields.forEach(field => {
    if (antibioticsUse[field.serverName] || antibioticsUse[field.serverName] === 0) {
      numberFieldsFromServer[field.reducerName] = antibioticsUse[field.serverName]
    }
  })


  let cefiderocolAdverseEvents = []

  if (antibioticsUse.cefiderocol_adverse_events && antibioticsUse.cefiderocol_adverse_events.length > 0) {
    cefiderocolAdverseEvents = antibioticsUse.cefiderocol_adverse_events.map(formatAdverseEventForReducer)
  } else if (antibioticsUse.patient_experienced_adverse_events === true) {
    cefiderocolAdverseEvents = [
      {id: 1, name: '', date_of_onset: null, event_duration_days: '', event_severity: '', event_seriousness: '', event_seriousness_reason: '', event_outcome: '', event_reported_to_health_authority: '', url: '', deleted: false, action_taken: '', time_to_onset: 0, indication_for_treatment: ''},
    ]
  }

  let additionalAntimicrobials = []

  if (antibioticsUse.additional_antimicrobials && antibioticsUse.additional_antimicrobials.length > 0) {
    additionalAntimicrobials = antibioticsUse.additional_antimicrobials.map((antimicrobial, index) => {
      return {
        id: index + 1,
        drug_name: antimicrobial.drug_name || '',
        initiation_date: parseDateFromServer(antimicrobial.initiation_date),
        end_date: parseDateFromServer(antimicrobial.end_date),
        url: antimicrobial.url || '',
      }
    })
  } else if (antibioticsUse.patient_received_other_antimicrobials === true) {
    additionalAntimicrobials = [
      {id: 1, drug_name: '', initiation_date: null, end_date: null, url: '',}
    ]
  }


  let icuAdmissions = []

  if (antibioticsUse.icu_admissions && antibioticsUse.icu_admissions.length > 0) {
    icuAdmissions = antibioticsUse.icu_admissions.map(formatICUAdmissionForReducer)
  } else if (antibioticsUse.patient_admitted_to_icu === true) {
    const newICUAdmission = createBlankICUAdmission(1)
    icuAdmissions.push(newICUAdmission)
  }

  const antibioticsUseFromServer = {
    ...numberFieldsFromServer,
    cefiderocolAdverseEvents,
    additionalAntimicrobials,
    icuAdmissions,
    reasonToStartCefiderocol: antibioticsUse.reason_to_start_cefiderocol || '',
    reasonToStartCefiderocolOtherText: antibioticsUse.reason_to_start_cefiderocol_other_text || '',
    cefiderocolInitiationDate: parseDateFromServer(antibioticsUse.cefiderocol_initiation_date),
    cefiderocolInitiationTime: parseTimeFromServer(antibioticsUse.cefiderocol_initiation_time),
    cefiderocolRecommendedBy: antibioticsUse.cefiderocol_recommended_by || '',
    cefiderocolRecommendedByOtherText: antibioticsUse.cefiderocol_recommended_by_other_text || '',
    attendingPhysicianSpecialty: antibioticsUse.attending_physician_specialty || '',
    cefiderocolEndDate: parseDateFromServer(antibioticsUse.cefiderocol_end_date),
    reasonForEndingCefiderocol: antibioticsUse.reason_for_ending_cefiderocol || '',
    reasonForEndingCefiderocolOtherText: antibioticsUse.reason_for_ending_cefiderocol_other_text || '',
    patientReceivedOtherAntimicrobials: antibioticsUse.patient_received_other_antimicrobials,
    clinicalAssessmentCefiderocolTreatment: antibioticsUse.clinical_assessment_of_cefiderocol_treatment || '',
    serumCreatineLevelUnit: antibioticsUse.serum_creatine_level_unit || '',

    gnbiMicrobiologyRepeated: antibioticsUse.gnbi_microbiology_repeated,
    gnbiDateOfSampleTest: parseDateFromServer(antibioticsUse.gnbi_date_of_sample_test),
    gnbiPathogens: antibioticsUse.gnbi_pathogens || '',

    // deviceRemovedOrReplaced: antibioticsUse.device_removed_or_replaced,
    // deviceRemovedOrReplacedDate: parseDateFromServer(antibioticsUse.device_removed_or_replaced_date),

    patientExperiencedAdverseEvents: antibioticsUse.patient_experienced_adverse_events,
    patientAdmittedToICU: antibioticsUse.patient_admitted_to_icu,

    antibioticsUseInfoUrl: antibioticsUse.url,
  }
  
  if (antibioticsUseFromServer.serumCreatineLevelUnit === 'umol/L') {
    antibioticsUseFromServer.serumCreatineLevelUnit = 'µmol/L'
  }

  return antibioticsUseFromServer
}


const formatAntibioticsUseForServer = (props) => {
  const {
    patientChartUrl,
    reasonToStartCefiderocolOtherText,
    reasonToStartCefiderocol,
    cefiderocolInitiationDate,
    cefiderocolInitiationTime,
    cefiderocolRecommendedBy,
    cefiderocolRecommendedByOtherText,
    attendingPhysicianSpecialty,
    cefiderocolStartingDoseGrams,
    cefiderocolInfusionTimeHours,
    cefiderocolInfusionFrequencyHours,
    patientBodyWeight,
    serumCreatineLevel,
    serumCreatineLevelUnit,
    cefiderocolEndDate,
    reasonForEndingCefiderocol,
    reasonForEndingCefiderocolOtherText,
    clinicalAssessmentCefiderocolTreatment,
    gnbiMicrobiologyRepeated,
    gnbiDateOfSampleTest,
    gnbiPathogens,
    // deviceRemovedOrReplaced,
    // deviceRemovedOrReplacedDate,
    patientExperiencedAdverseEvents,
    patientReceivedOtherAntimicrobials,
    patientAdmittedToICU,
  } = props

  return {
    patient_chart: patientChartUrl,
    reason_to_start_cefiderocol: reasonToStartCefiderocol || null,
    reason_to_start_cefiderocol_other_text: reasonToStartCefiderocolOtherText || null,
    cefiderocol_initiation_date: formatDateForServer(cefiderocolInitiationDate),
    cefiderocol_initiation_time: formatTimeForServer(cefiderocolInitiationTime),
    cefiderocol_recommended_by: cefiderocolRecommendedBy || null,
    cefiderocol_recommended_by_other_text: cefiderocolRecommendedByOtherText || null,
    attending_physician_specialty: attendingPhysicianSpecialty || null,
    cefiderocol_starting_dose_grams: cefiderocolStartingDoseGrams || null,
    cefiderocol_infusion_time_hours: cefiderocolInfusionTimeHours || null,
    cefiderocol_infusion_frequency_hours: cefiderocolInfusionFrequencyHours || null,
    patient_body_weight_kg: patientBodyWeight || null,
    serum_creatine_level_value: serumCreatineLevel || null,
    serum_creatine_level_unit: serumCreatineLevelUnit || null,
    cefiderocol_end_date: formatDateForServer(cefiderocolEndDate),
    reason_for_ending_cefiderocol: reasonForEndingCefiderocol || null,
    reason_for_ending_cefiderocol_other_text: reasonForEndingCefiderocolOtherText || null,
    patient_received_other_antimicrobials: patientReceivedOtherAntimicrobials,
    clinical_assessment_of_cefiderocol_treatment: clinicalAssessmentCefiderocolTreatment || null,

    gnbi_microbiology_repeated: gnbiMicrobiologyRepeated,
    gnbi_date_of_sample_test: formatDateForServer(gnbiDateOfSampleTest),
    gnbi_pathogens: gnbiPathogens  || '',

    // device_removed_or_replaced: deviceRemovedOrReplaced,
    // device_removed_or_replaced_date: formatDateForServer(deviceRemovedOrReplacedDate),

    patient_experienced_adverse_events: patientExperiencedAdverseEvents,
    patient_admitted_to_icu: patientAdmittedToICU,
  }
}


export const submitChartAntibioticsUse = (props, goToNextPhase, manualSave=false) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingChartPhase())

    const { antibioticsUseInfoUrl } = props

    let method, url

    if (antibioticsUseInfoUrl) {
      method = "PATCH"
      url = antibioticsUseInfoUrl
    } else {
      method = "POST"
      url = `${getServerUrl()}/antibiotics-uses/`
    }

    const antibioticsUseInfo = formatAntibioticsUseForServer(props)
    if (props.override_date) {
      antibioticsUseInfo.override_date = true
      antibioticsUseInfo.reason = props.dateOverrideReason
    }

    axios({
      method,
      url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: antibioticsUseInfo,
    })
    .then(response => {
      if (response?.data?.screening_failure && !manualSave) {
        dispatch({ type: "TOGGLE_ANTIBIOTICS_SCREENING_FAILURE", payload: true })
        dispatch(handleChartFieldChange('screeningFailure', true))
      } else {
        dispatch({ type: "TOGGLE_ANTIBIOTICS_SCREENING_FAILURE", payload: false })
        dispatch(handleChartFieldChange('screeningFailure', false))
      }
      dispatch(chartAntibioticsUseHasBeenSaved(response.data.url, goToNextPhase))
    })
    .catch(error => {
      if (error?.response?.data?.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        //there will only be one key if the error is that the selected date is after todays date
        if (joinError.split('[')[1].includes(',')) {
          //thirdKey will always point to override, if true date is overridable
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          let thirdKey = joinError.split('[')[1].split(',')[2].split(']')[0].split(' ')[1]
          if (antibioticsUseInfo[`${firstKey}`]) {
            let firstArr = firstKey.split('_')
            let firstJouned = firstArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let firstCamelCase = firstJouned.charAt(0).toLowerCase() + firstJouned.slice(1)
            if (props.chartDateErrorMessage === firstCamelCase) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                dispatch(handleChartFieldChange('antibioticsUseDateOverride', props))
              } else {
                props[`${firstCamelCase}`] = null
                dispatch(submitChartAntibioticsUse(props))
                dispatch(handleAntibioticsUseChartFieldChange(firstCamelCase, null))
              }
            }
          }
          if (antibioticsUseInfo[`${secondKey}`]) {
            let secondArr = secondKey.split('_')
            let secondJoined = secondArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let secondCamelCase = secondJoined.charAt(0).toLowerCase() + secondJoined.slice(1)
            if (props.chartDateErrorMessage === secondCamelCase) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                dispatch(handleChartFieldChange('antibioticsUseDateOverride', props))
              } else {
                props[`${secondCamelCase}`] = null
                dispatch(submitChartAntibioticsUse(props))
                dispatch(handleAntibioticsUseChartFieldChange(secondCamelCase, null))
              }
            }
          }
        } else {
          let arr = firstKey.split('_')
          let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
          let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
          if (props.chartDateErrorMessage === camelCase) {
            props[`${camelCase}`] = null
            dispatch(submitChartAntibioticsUse(props))
            dispatch(handleAntibioticsUseChartFieldChange(camelCase, null))
          }
        }
        return dispatch(errorSavingChartDate(error, "Antibiotics Use"))
      } else {
        return dispatch(errorSavingChartPhase(error, "Antibiotics Use", dispatch))
      }
    })
  }
}




// ======================================================
// Additional Antimicrobial actions
// ======================================================


 export const togglePatientReceivedAdditionalAntimicrobials = (patientReceivedOtherAntimicrobials, props) => {
    return (dispatch) => {
      if (patientReceivedOtherAntimicrobials === false && props?.additionalAntimicrobials) {
        props.additionalAntimicrobials.forEach(antimicrobial => {
          dispatch(deleteAdditionalAntimicrobial(antimicrobial))
        })
      }
      return dispatch({
        type: "ANTIBIOTICS_USE_TOGGLE_PATIENT_RECEIVED_ADDITIONAL_ANTIMICROBIALS",
        payload: patientReceivedOtherAntimicrobials
      })
    }
 }

 export const handleAdditionalAntimicrobialsFieldChange = (id, name, value) => {
   const payload = { id, name, value }
   return { type: "ANTIBIOTICS_USE_ADDITIONAL_ANTIMICROBIAL_FIELD_CHANGE", payload }
 }


 export const addAdditionalAntimicrobial = (number) => {
   const payload = {id: number, drug_name: '', initiation_date: null, end_date: null}

   return { type: "ANTIBIOTICS_USE_ADD_ADDITIONAL_ANTIMICROBIAL", payload }
 }


const savingAdditionalAntimicrobial = () => {
  return { type: "ANTIBIOTICS_USE_SAVING_ADDITIONAL_ANTIMICROBIAL" }
}

export const submitAdditionalAntimicrobial = (antimicrobial) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingAdditionalAntimicrobial())
    dispatch(savingChartPhase())

    let method, url

    if (antimicrobial.url) {
      method = "PATCH"
      url = antimicrobial.url
    } else {
      method = "POST"
      url = `${getServerUrl()}/additional-antimicrobials/`
    }

    const formattedAntimicrobial = {}

    for (let [key, value] of Object.entries(antimicrobial)) {
      formattedAntimicrobial[key] = value || null
    }

    formattedAntimicrobial.initiation_date = formatDateForServer(antimicrobial.initiation_date)
    formattedAntimicrobial.end_date = formatDateForServer(antimicrobial.end_date)

    axios({
      method,
      url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: formattedAntimicrobial,
    })
    .then(response => {
      dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, 'url', response.data.url))
      return dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, 'dateErrorMessage', ''))
    })
    .catch(error => {
      if (error?.response?.data?.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        //there will only be one key if the error is that the selected date is after todays date
        if (joinError.split('[')[1].includes(',')) {
          //thirdKey will always point to override, if true date is overridable
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          let thirdKey = joinError.split('[')[1].split(',')[2].split(']')[0].split(' ')[1]
          if (antimicrobial[firstKey]) {
            if (antimicrobial.dateNameToCheckForError === firstKey) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                dispatch(handleChartFieldChange('antibioticsUseDateOverride', antimicrobial))
              } else {
                antimicrobial[firstKey] = null
                dispatch(submitChartAntibioticsUse(antimicrobial))
                dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, firstKey, null))
              }
            }
          }
          if (antimicrobial[secondKey]) {
            if (antimicrobial.dateNameToCheckForError === secondKey) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                dispatch(handleChartFieldChange('antibioticsUseDateOverride', antimicrobial))
              } else {
                antimicrobial[secondKey] = null
                dispatch(submitChartAntibioticsUse(antimicrobial))
                dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, secondKey, null))
              }
            }
          }
        } else {
          let antimicrobialKey = firstKey.split(']')[0]
          if (antimicrobial.dateNameToCheckForError === antimicrobialKey) {
            antimicrobial[antimicrobialKey] = null
            dispatch(submitChartAntibioticsUse(antimicrobial))
            dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, antimicrobialKey, null))
          }
        }
        return dispatch(handleAdditionalAntimicrobialsFieldChange(antimicrobial.id, 'dateErrorMessage', joinError))
      }
      return dispatch(errorSavingChartPhase(error, "Antibiotics Use", dispatch))
    })
    .finally(() => {
      dispatch(chartFieldSaved())
    })
  }
 }

 const removeAdditionalAntimicrobial = (id) => {
   return {type: 'ANTIBIOTICS_USE_REMOVE_ADDITIONAL_ANTIMICROBIAL', payload: id}
 }


 export const deleteAdditionalAntimicrobial = (antimicrobial) => {
   return (dispatch) => {
     if (!antimicrobial.url) {
        return dispatch(removeAdditionalAntimicrobial(antimicrobial.id))
     } else {
       dispatch(savingChartPhase())
       axios({
         method: 'DELETE',
         url: antimicrobial.url,
         headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
       })
       .then(response => {
         return dispatch(removeAdditionalAntimicrobial(antimicrobial.id))
       })
       .catch(error => {
         return dispatch(errorSavingChartPhase(error, "Additional Antimicrobial", dispatch))
       })
        .finally(() => {
          dispatch(chartFieldSaved())
        })
     }
   }
 }



 // ======================================================
 // Cefiderocol Adverse Events actions
 // ======================================================


export const togglePatientExperiencedAdverseEvents = (patientHadAdverseReaction, props) => {
  return (dispatch) => {
    if (patientHadAdverseReaction === false && props?.cefiderocolAdverseEvents) {
      props.cefiderocolAdverseEvents.forEach(adveseReaction => {
        dispatch(deleteAdverseEvent(adveseReaction))
      })
    }
    return dispatch({
      type: "ANTIBIOTICS_USE_TOGGLE_PATIENT_EXPERIENCED_ADVERSE_EVENTS",
      payload: patientHadAdverseReaction,
    })
  }
}


export const handleAdverseEventFieldChange = (id, name, value) => {
 const payload = { id, name, value }
 return { type: "ANTIBIOTICS_USE_ADVERSE_EVENT_FIELD_CHANGE", payload }
}


export const addCefiderocolAdverseEvent = (number) => {
  const payload = {
    id: number,
    name: '',
    date_of_onset: null,
    event_duration_days: '',
    event_severity: '',
    event_seriousness: '',
    event_seriousness_reason: '',
    event_reported_to_health_authority: '',
    event_outcome: '',
    deleted: false,
    action_taken: '',
    time_to_onset: 0,
    indication_for_treatment: '',
    url: ''
  }

  return { type: "ANTIBIOTICS_USE_ADD_CEFIDEROCOL_ADVERSE_EVENT", payload }
}


const savingAdverseEvent = () => {
  return { type: "ANTIBIOTICS_USE_SAVING_CEFIDEROCOL_ADVERSE_EVENT" }
}

const saveAdverseEvent = (adverseEvent) => {
  let method, url

  if (adverseEvent.url) {
    method = "PATCH"
    url = adverseEvent.url
  } else {
    method = "POST"
    url = `${getServerUrl()}/cefiderocol-adverse-events/`
  }

  const formattedAdverseEvent = {}

  for (let [key, value] of Object.entries(adverseEvent)) {
    if (key !== 'site') {
      formattedAdverseEvent[key] = value || null
    }
  }

  formattedAdverseEvent.date_of_onset = formatDateForServer(adverseEvent.date_of_onset)
  formattedAdverseEvent.deleted = adverseEvent.deleted
  formattedAdverseEvent.addressed = adverseEvent.addressed
  formattedAdverseEvent.action_taken = adverseEvent.action_taken || null
  return axios({
    method,
    url,
    headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    data: formattedAdverseEvent,
  })
}

export const submitCefiderocolAdverseEvent = (adverseEvent) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    const savingCefiderocolAdverseEvent = getState().chartFormReducer.savingCefiderocolAdverseEvent
    if (chartIsSaving || savingCefiderocolAdverseEvent) {
      return dispatch({ type: '' })
    }

    dispatch(savingAdverseEvent())
    dispatch(savingChartPhase())

    saveAdverseEvent(adverseEvent)
    .then(response => {
      return dispatch(handleAdverseEventFieldChange(adverseEvent.id, 'url', response.data.url))
    })
    .catch(error => {
      if (error?.response?.data?.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        if (joinError.split('[')[1].includes(',')) {
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          if (adverseEvent[`${firstKey}`] && adverseEvent.chartDateErrorMessage === firstKey) {
            adverseEvent[`${firstKey}`] = null
            dispatch(submitCefiderocolAdverseEvent(adverseEvent))
            dispatch(handleAdverseEventFieldChange(adverseEvent.id, firstKey, null))
          }
          if (adverseEvent[`${secondKey}`] && adverseEvent.chartDateErrorMessage === secondKey) {
            adverseEvent[`${secondKey}`] = null
            dispatch(submitCefiderocolAdverseEvent(adverseEvent))
            dispatch(handleAdverseEventFieldChange(adverseEvent.id, secondKey, null))
          }
        } else {
          let key = firstKey.split(']')[0]
          if (adverseEvent.chartDateErrorMessage === key) {
            adverseEvent[`${key}`] = null
            dispatch(submitCefiderocolAdverseEvent(adverseEvent))
            dispatch(handleAdverseEventFieldChange(adverseEvent.id, key, null))
          }
        }

        return dispatch(errorSavingChartDate(error, "Adverse Drug Reaction"))
      } else {
        return dispatch(errorSavingChartPhase(error, "Adverse Drug Reaction", dispatch))
      }
    })
    .finally(() => {
      dispatch(chartFieldSaved())
    })
  }
 }

 const formatAdverseEventForReducer = (adverseEvent, index) => {
   return {
     id: index + 1,
     name: adverseEvent.name || '',
     date_of_onset: parseDateFromServer(adverseEvent.date_of_onset),
     event_duration_days: adverseEvent.event_duration_days || null,
     event_severity: adverseEvent.event_severity || '',
     event_seriousness: adverseEvent.event_seriousness || '',
     event_seriousness_reason: adverseEvent.event_seriousness_reason || '',
     event_outcome: adverseEvent.event_outcome || '',
     event_reported_to_health_authority: adverseEvent.event_reported_to_health_authority || '',
     url: adverseEvent.url || '',
     deleted: adverseEvent.deleted || false,
     addressed: adverseEvent.addressed || false,
     action_taken: adverseEvent.action_taken || '',
     time_to_onset: adverseEvent.time_to_onset || null,
     indication_for_treatment: adverseEvent.indication_for_treatment || '',
     site: adverseEvent.site || adverseEvent.patient_chart.site,
     antibiotics_use: adverseEvent.antibiotics_use || null,
     requires_revisions: adverseEvent.requires_revisions,
   }
 }

 // eslint-disable-next-line
 const removeAdverseEvent = (id) => {
   return {type: 'ANTIBIOTICS_USE_REMOVE_CEFIDEROCOL_ADVERSE_EVENT', payload: id}
 }

export const deleteAdverseEvent = (adverseEvent) => {
  return (dispatch) => {
    if (!adverseEvent.url) {
      return dispatch(removeAdverseEvent(adverseEvent.id))
    } else {
      dispatch(savingAdverseEvent())
      dispatch(savingChartPhase())

      axios({
        method: "PATCH",
        url: adverseEvent.url,
        headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
        data: { deleted: true }
      })
      .then(response => {
          dispatch(removeAdverseEvent(adverseEvent.id))
          return dispatch(handleAdverseEventFieldChange(adverseEvent.id, 'url', response.data.url))
      })
      .catch(error => {
        dispatch(errorSavingChartPhase(error, 'deleting the adverse drug reaction', dispatch))
      })
      .finally(() => {
        dispatch(chartFieldSaved())
      })
    }
  }
}





// ======================================================
// ICU Admission actions
// ======================================================


const createBlankICUAdmission = (number) => {
  return {
    id: number,
    icu_admission_date: null,
    icu_discharge_date: null,
    icu_admission_reason: '',
    apache_ii_score_assessed: true,
    apache_ii_score: '',
    icu_discharge_description: '',
    patient_required_organ_support: false,
    organ_supports: [],
  }
}


export const togglePatientWasAdmittedToICU = (patientAdmittedToICU, props) => {
  return (dispatch) => {
    if (patientAdmittedToICU === false && props?.icuAdmissions) {
      props.icuAdmissions.forEach(admission => {
        dispatch(deleteICUAdmission(admission))
      })
    }
    return dispatch({
      type: "ANTIBIOTICS_USE_TOGGLE_PATIENT_WAS_ADMITTED_TO_ICU",
      payload: patientAdmittedToICU
    })
  }
}


export const handleICUAdmissionFieldChange = (id, name, value) => {
 const payload = { id, name, value }
 return { type: "ANTIBIOTICS_USE_ICU_ADMISSION_FIELD_CHANGE", payload }
}


export const addICUAdmission = (number) => {
  const payload = createBlankICUAdmission(number)
  return { type: "ANTIBIOTICS_USE_ADD_ICU_ADMISSION_INSTANCE", payload }
}


const savingICUAdmission = () => {
 return { type: "ANTIBIOTICS_USE_SAVING_ICU_ADMISSION_INSTANCE" }
}

const saveICUAdmission = (icuAdmission) => {

  let method, url

  if (icuAdmission.url) {
    method = "PATCH"
    url = icuAdmission.url
  } else {
    method = "POST"
    url = `${getServerUrl()}/icu-admissions/`
  }

  const formattedICUAdmission = {
    icu_admission_date: formatDateForServer(icuAdmission.icu_admission_date),
    icu_discharge_date: icuAdmission.icu_discharge_date ? formatDateForServer(icuAdmission.icu_discharge_date) : null,
    icu_admission_reason: icuAdmission.icu_admission_reason || null,
    apache_ii_score_assessed: icuAdmission.apache_ii_score_assessed,
    apache_ii_score: icuAdmission.apache_ii_score || icuAdmission.apache_ii_score === 0 ? icuAdmission.apache_ii_score : null,
    icu_discharge_description: icuAdmission.icu_discharge_description || null,
    patient_required_organ_support: icuAdmission.patient_required_organ_support,
    antibiotics_use: icuAdmission.antibiotics_use,
  }

  return axios({
    method,
    url,
    headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    data: formattedICUAdmission,
  })
}

export const submitICUAdmission = (icuAdmission) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    const savingICUAdmissions = getState().chartFormReducer.savingICUAdmissions
    if (chartIsSaving || savingICUAdmissions) {
      return dispatch({ type: '' })
    }

    dispatch(savingICUAdmission())
    dispatch(savingChartPhase())
    saveICUAdmission(icuAdmission)
    .then(response => {
      return dispatch(handleICUAdmissionFieldChange(icuAdmission.id, 'url', response.data.url))
    })
    .catch(error => {
      if (error.response.data.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        if (joinError.split('[')[1].includes(',')) {
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          if (icuAdmission[`${firstKey}`] && icuAdmission.chartDateErrorMessage === firstKey) {
            icuAdmission[`${firstKey}`] = null
            dispatch(submitICUAdmission(icuAdmission))
            dispatch(handleICUAdmissionFieldChange(icuAdmission.id, firstKey, null))
          }
          if (icuAdmission[`${secondKey}`] && icuAdmission.chartDateErrorMessage === secondKey) {
            icuAdmission[`${secondKey}`] = null
            dispatch(submitICUAdmission(icuAdmission))
            dispatch(handleICUAdmissionFieldChange(icuAdmission.id, secondKey, null))
          }
        } else {
          let key = firstKey.split(']')[0]
          if (icuAdmission.chartDateErrorMessage === key) {
            icuAdmission[`${key}`] = null
            dispatch(submitICUAdmission(icuAdmission))
            dispatch(handleICUAdmissionFieldChange(icuAdmission.id, key, null))
          }
        }

        return dispatch(errorSavingChartDate(error, "ICU Admission"))
      } else {
        return dispatch(errorSavingChartPhase(error, "ICU Admission", dispatch))
      }
    })
    .finally(() => {
      dispatch(chartFieldSaved())
    })
  }
}



const formatICUAdmissionForReducer = (icuAdmission, index) => {
  let organ_supports = []
  if (icuAdmission.organ_supports) {
    organ_supports = icuAdmission.organ_supports.map(formatOrganSupportForReducer)
  }

  return {
    id: index + 1,
    icu_admission_date: parseDateFromServer(icuAdmission.icu_admission_date),
    icu_discharge_date: parseDateFromServer(icuAdmission.icu_discharge_date),
    icu_admission_reason: icuAdmission.icu_admission_reason || '',
    apache_ii_score_assessed: icuAdmission.apache_ii_score_assessed,
    apache_ii_score: icuAdmission.apache_ii_score || '',
    icu_discharge_description: icuAdmission.icu_discharge_description || '',
    patient_required_organ_support: icuAdmission.patient_required_organ_support,
    url: icuAdmission.url || '',
    organ_supports,
  }
}



const removeICUAdmission = (id) => {
  return {type: 'ANTIBIOTICS_USE_REMOVE_ICU_ADMISSION_INSTANCE', payload: id}
}


export const deleteICUAdmission = (icuAdmission) => {
  return (dispatch) => {
    if (!icuAdmission.url) {
      return dispatch(removeICUAdmission(icuAdmission.id))
    } else {
      dispatch(savingChartPhase())
      axios({
        method: 'DELETE',
        url: icuAdmission.url,
        headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      })
      .then(response => {
        return dispatch(removeICUAdmission(icuAdmission.id))
      })
      .catch(error => {
        return dispatch(errorSavingChartPhase(error, "ICU Admission", dispatch))
      })
      .finally(() => {
        dispatch(chartFieldSaved())
      })
    }
  }
}



// ======================================================
// ICU Admission Organ Support actions
// ======================================================

const createBlankICUAdmissionOrganSupport = (props, number, name = '') => {
  return {
    icu_admission: props.icuAdmissionUrl,
    id: number,
    url: '',
    name,
    start_date: null,
    end_date: null,
    reason: '',
  }
}

export const addICUAdmissionOrganSupport = (props, number, name) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingChartPhase())
    const organSupport = createBlankICUAdmissionOrganSupport(props, number, name)
    saveOrganSupport(organSupport)
    .then(response => {
      const savedOrganSupport = { ...organSupport, url: response.data.url }
      const updatedOrganSupports = [...props.organ_supports, savedOrganSupport]
      return dispatch(handleICUAdmissionFieldChange(props.id, 'organ_supports', updatedOrganSupports))
    })
    .catch(error => {
      return dispatch(errorSavingChartPhase(error, "ICU Admission", dispatch))
    })
    .finally(() => {
      dispatch(chartFieldSaved())
    })
  }
}

export const handleICUAdmissionOrganSupportFieldChange = (id, name, value, props) => {
  return (dispatch) => {
    const organSupports = updateAssociatedField(id, name, value, props.organ_supports)
    return dispatch(handleICUAdmissionFieldChange(props.icuAdmissionId, 'organ_supports', organSupports))
  }
}

const formatOrganSupportForServer = (organSupport) => {
  return {
    icu_admission: organSupport.icu_admission,
    name: organSupport.name || null,
    start_date: formatDateForServer(organSupport.start_date),
    end_date: formatDateForServer(organSupport.end_date),
    reason: organSupport.reason || null,
  }
}

const formatOrganSupportForReducer = (organSupport, index) => {
  return {
    icu_admission: organSupport.icu_admission,
    id: index,
    url: organSupport.url || null,
    name: organSupport.name || '',
    start_date: parseDateFromServer(organSupport.start_date),
    end_date: parseDateFromServer(organSupport.end_date),
    reason: organSupport.reason || '',
  }
}

const saveOrganSupport = (organSupport) => {
 let method, url

 if (organSupport.url) {
   method = "PATCH"
   url = organSupport.url
 } else {
   method = "POST"
   url = `${getServerUrl()}/organ-supports/`
 }

 const formattedOrganSupport = formatOrganSupportForServer(organSupport)

 return axios({
   method,
   url,
   headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
   data: formattedOrganSupport,
 })
}

export const submitOrganSupport = (props, dateName) => {
  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    if (props && dateName) {
      console.log(props);
      let organSupportsWithUpdatedDate = updateAssociatedField(props.id, `dateValidationErrorMessage${dateName}`, '', props.organ_supports)
      organSupportsWithUpdatedDate = updateAssociatedField(props.id, dateName, props[dateName], organSupportsWithUpdatedDate)
      dispatch(handleICUAdmissionFieldChange(props.icuAdmissionId, 'organ_supports', organSupportsWithUpdatedDate))
    }

    dispatch(savingChartPhase())
    saveOrganSupport(props)
    .then(response => {
      return dispatch({ type: '' })
    })
    .catch(error => {
      if (error?.response?.data?.non_field_errors) {
        const errorData = error.response.data.non_field_errors
        if (Array.isArray(errorData) && errorData[0] && errorData[0].includes('Validation Error')) {
          if (typeof dateName === 'string') {
            const errorMessage = errorData[0].includes('[') && errorData[0].includes(']') ?
              errorData[0].slice(0, errorData[0].indexOf('[')) :
              errorData[0]
            const errorMessageKey = `dateValidationErrorMessage${dateName}`
            let organSupports = updateAssociatedField(props.id, dateName, null, props.organ_supports)
            organSupports = updateAssociatedField(props.id, errorMessageKey, errorMessage, organSupports)
            return dispatch(handleICUAdmissionFieldChange(props.icuAdmissionId, 'organ_supports', organSupports))
          }
        }
      }
      return dispatch(errorSavingChartPhase(error, "ICU Admission", dispatch))
    })
    .finally(() => {
      dispatch(chartFieldSaved())
    })
  }
}


export const removeOrganSupport = (props) => {
  return (dispatch) => {
    const updatedOrganSupports = props.organ_supports.filter(organSupport => organSupport.id !== props.id)

    return dispatch(handleICUAdmissionFieldChange(props.icuAdmissionId, 'organ_supports', updatedOrganSupports))
  }
}


export const deleteOrganSupport = (props) => {
  return (dispatch) => {
    if (!props.url) {
       return dispatch(removeOrganSupport(props))
    } else {
      dispatch(savingChartPhase())
      axios({
        method: 'DELETE',
        url: props.url,
        headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      })
      .then(response => {
        return dispatch(removeOrganSupport(props))
      })
      .catch(error => {
        return dispatch(errorSavingChartPhase(error, "Organ Support", dispatch))
      })
      .finally(() => {
        dispatch(chartFieldSaved())
      })
    }
  }
}
